// extracted by mini-css-extract-plugin
export var chipContainer = "CheppersExpert-module--chipContainer--44dfb";
export var container = "CheppersExpert-module--container--b2822";
export var description = "CheppersExpert-module--description--7fb12";
export var header = "CheppersExpert-module--header--73016";
export var image = "CheppersExpert-module--image--b05bc";
export var name = "CheppersExpert-module--name--4b23a";
export var position = "CheppersExpert-module--position--a8142";